import React from "react";
import { appStoreLink, downloadButtons, getIsMobile, getIsTablet } from "../globalConstants";
import { DownloadButtonsMobile } from "./DownloadButtonsMobile";
import { trackDownloadClick, CtaPlacement } from "../analytics/events";


interface DownloadButtonsDesktopProps {
    height?: string | number
    width?: string | number
    /** Which section this instance sits in, reported with the GA4 download_click event. */
    placement?: CtaPlacement
}


export const DownloadButtonsDesktop: React.FC<DownloadButtonsDesktopProps> = ({ height = "15%", placement = "unknown" }) => {
    try {

        return (
            <div

                className="download-buttons"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                    width: "100%",
                    height: height,
                    position: "relative",
                    zIndex: 20,
                }}
            >
                {downloadButtons.map((button, i) => {
                    const isLeft: boolean = (i % 2 === 0);
                    return (
                        <div
                            className="button-container"
                            style={{
                                display: "flex",
                                marginLeft: "5%",
                                marginRight: "5%",
                                justifyContent: "center",
                                flexDirection: "column",
                                zIndex: 100,
                                width: "auto",
                                height: "100%",
                                backgroundColor: "#a7a7a7",
                                cursor: "pointer",
                                alignItems: "center",
                                position: "relative",
                                transition: "transform 0.3s ease, box-shadow 0.3s ease", // ← add box-shadow here
                                borderRadius: button.link == appStoreLink ? 15 : 10,     // ← match image radius
                                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)",              // ← shadow on container

                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "scale(1.2)";
                                e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // ← golden glow here
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "scale(1)";
                                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)";  // ← reset here
                            }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    height: "100%",
                                    width: "100%",
                                    flex: 1,
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <img
                                    src={button.source}
                                    className="download-image"
                                    style={{
                                        height: "100%",      // ← match container height
                                        width: "auto",       // ← let width scale naturally
                                        borderRadius: button.link == appStoreLink ? 15 : 10,
                                        objectFit: "contain",
                                        transition: "box-shadow 0.3s ease", // Smooth shadow transition
                                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)", // Default shadow
                                        display: "block", // ← removes the default inline gap under images
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(229,189,23,0.8)"; // Golden glow on hover
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.5)"; // Return to default shadow
                                    }}
                                    alt=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        trackDownloadClick(button.link, placement);
                                        window.open(button.link);
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    } catch (err) {
        console.error('DownloadButtonsDesktop:' + err)
        return (<div></div>)
    }
}


